// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* Base styles used by Scratch https://github.com/LLK/scratch-www/blob/develop/src/main.scss */

h1,
h2,
h3,
h4,
h5,
p {
    margin: 0;
    padding: 0;
    border: 0;
}

h1,
h2,
h3,
h4,
h5 {
    font-weight: bold;
    line-height: 1.7em;
}

h1 {
    font-weight: 2.5rem;
}

h2 {
    font-weight: 2rem;
}

h3 {
    font-size: 1.4rem;
}

h4 {
    font-size: 1rem;
}

a {
    color: var(--link-color);
    cursor: pointer;
    text-decoration: underline;
}

.interface_container_uYA1D {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: var(--page-background);
}

.interface_editor_lI2gX {
    height: 100%;
}

.interface_editor_lI2gX .interface_center_rSxMk {
    height: 100%;
}

.interface_player-only__MGmB .interface_center_rSxMk {
    margin: auto;
}

.interface_menu_lqZkn {
    margin-bottom: 8px;
}

.interface_section_sBMjS {
    margin: 8px 0 8px 0;
}

.interface_footer_dLhK2 {
    padding: 10px 0;
    margin-top: 10px;
    border-top: 2px solid var(--ui-black-transparent);
}

.interface_footer_dLhK2 a {
    font-weight: bold;
    text-decoration: none;
}

.interface_footer-content_KvTod {
    max-width: 600px;
    margin: auto;
}

.interface_footer-text_kFpVx {
    text-align: center;
    margin: 5px 0 10px 0;
}

.interface_footer-columns_tcZeb {
    display: flex;
    justify-content: center;
    justify-items: center;
    flex-wrap: wrap;
}

.interface_footer-section_FdP5t {
    display: flex;
    flex-direction: column;
    width: 200px;
    margin-bottom: 10px;
}

.interface_footer-section_FdP5t > * {
    margin-bottom: 10px;
}

.interface_infobox_AbZXo {
    line-height: 1.5em;
    padding: 0.5rem;
    margin: 5px 0 8px 0;
    border-radius: 0.5rem;
    border: 1px solid #b9d6ff;
    background-color: #dbebff;
}

.interface_infobox_AbZXo p {
    margin: 4px 0;
}

.interface_infobox_AbZXo a {
    font-weight: bold;
    text-decoration: none;
}

.interface_unshared-update_wZeR8 {
    border-color: #ff52526e;
    background-color: #ff525240;
}
`, "",{"version":3,"sources":["webpack://./src/playground/interface.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,8FAA8F;;AAE9F;;;;;;IAMI,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;;;;;IAKI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* Base styles used by Scratch https://github.com/LLK/scratch-www/blob/develop/src/main.scss */\n\nh1,\nh2,\nh3,\nh4,\nh5,\np {\n    margin: 0;\n    padding: 0;\n    border: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n    font-weight: bold;\n    line-height: 1.7em;\n}\n\nh1 {\n    font-weight: 2.5rem;\n}\n\nh2 {\n    font-weight: 2rem;\n}\n\nh3 {\n    font-size: 1.4rem;\n}\n\nh4 {\n    font-size: 1rem;\n}\n\na {\n    color: var(--link-color);\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: var(--page-background);\n}\n\n.editor {\n    height: 100%;\n}\n\n.editor .center {\n    height: 100%;\n}\n\n.player-only .center {\n    margin: auto;\n}\n\n.menu {\n    margin-bottom: 8px;\n}\n\n.section {\n    margin: 8px 0 8px 0;\n}\n\n.footer {\n    padding: 10px 0;\n    margin-top: 10px;\n    border-top: 2px solid var(--ui-black-transparent);\n}\n\n.footer a {\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.footer-content {\n    max-width: 600px;\n    margin: auto;\n}\n\n.footer-text {\n    text-align: center;\n    margin: 5px 0 10px 0;\n}\n\n.footer-columns {\n    display: flex;\n    justify-content: center;\n    justify-items: center;\n    flex-wrap: wrap;\n}\n\n.footer-section {\n    display: flex;\n    flex-direction: column;\n    width: 200px;\n    margin-bottom: 10px;\n}\n\n.footer-section > * {\n    margin-bottom: 10px;\n}\n\n.infobox {\n    line-height: 1.5em;\n    padding: 0.5rem;\n    margin: 5px 0 8px 0;\n    border-radius: 0.5rem;\n    border: 1px solid #b9d6ff;\n    background-color: #dbebff;\n}\n\n.infobox p {\n    margin: 4px 0;\n}\n\n.infobox a {\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.unshared-update {\n    border-color: #ff52526e;\n    background-color: #ff525240;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `interface_container_uYA1D`,
	"editor": `interface_editor_lI2gX`,
	"center": `interface_center_rSxMk`,
	"player-only": `interface_player-only__MGmB`,
	"playerOnly": `interface_player-only__MGmB`,
	"menu": `interface_menu_lqZkn`,
	"section": `interface_section_sBMjS`,
	"footer": `interface_footer_dLhK2`,
	"footer-content": `interface_footer-content_KvTod`,
	"footerContent": `interface_footer-content_KvTod`,
	"footer-text": `interface_footer-text_kFpVx`,
	"footerText": `interface_footer-text_kFpVx`,
	"footer-columns": `interface_footer-columns_tcZeb`,
	"footerColumns": `interface_footer-columns_tcZeb`,
	"footer-section": `interface_footer-section_FdP5t`,
	"footerSection": `interface_footer-section_FdP5t`,
	"infobox": `interface_infobox_AbZXo`,
	"unshared-update": `interface_unshared-update_wZeR8`,
	"unsharedUpdate": `interface_unshared-update_wZeR8`
};
export default ___CSS_LOADER_EXPORT___;
